export const locale = {
    lang: 'pt',
    data: {
      'RESULTADOS': {
        'TITULO': 'RESULTADOS',
        'DESCRIP': 'Seleccione uma opção',
        'CARGANDO': 'Carregamento dos resultados do inquérito às empresas',
        'COMINGSOON': 'Resultados do inquérito COVID em breve...',
        'VALIDANDO': {
          'BOTON': 'No processo de validação',
          'MENSAJE': 'Os resultados deste produto estão a ser validados e em breve serão disponibilizados',
        },
        'TABLAPRODUCTOS':{
          'COL1':'Ano',
          'COL2':'Acesso',
          'BOT':'Acesso',
        },

        'SECCIONES': {
          'TITULO_VER':'Versão ',
          'NOSECCIONES': 'Não há secções disponíveis',
          'CERTIFICAR': {
            'TITULO': 'CERTIFICAR',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
          'MEDIR': {
            'TITULO': 'MEDIÇÃO',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
          'PULSE': {
            'TITULO': 'PULSE CHECK',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
          'MEDIR_AMCO': {
            'TITULO': 'ICI',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
          'MEDIR_INNO': {
            'TITULO': 'Innmotion survey',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
          'CertiAdicio': {
            'TITULO': 'CERTIFICAÇÕES ADICIONAIS',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
          'Amco': {
            'TITULO': 'AMCO',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
          'TrabDign': {
            'TITULO': 'TRABALHO DIGNIFICANTE',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
          'PrimEmp': {
            'TITULO': 'PRIMEIRO TRABALHO',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
          'GOFLOW': {
            'TITULO': 'Resultados GoFlow',
            'INFO': 'Seleccione o ano que pretende consultar',
            'BOTON': 'Entrar'
          },
        },
        'TABPRIN':{
          'TABPRO':'Processo de certificação',
          'TAB4ALL':'Resultados FORALL',
          'TAB4ALL2':'Processo de FORALL',
          'TITURES':'Resultados FORALL',
          'TABCER':'Processos de medição',
          'TABPULSE':'Processos de pulse check',
          'TABICI': 'Resultados ICI',
          'TABINNO': 'Resultados Innmotion survey',
          'TABAMCO': 'Processos AMCO',
          'TABTRABDIG': 'Processos de Trabalho Decente',
          'TABPRIEMP': 'Primeiros processos de emprego',
        },
        '4ALLVIEJAS':{
         'TITULO': 'FORALL resultados herdados',
         'BOTON': 'Início',
         'SIN_4ALL_HEREDADAS':'Não tem resultados herdados de FORALL',
         'TITULOCERTIFICAR':'Certificar',
         'APLICACIONANIO':'Ano de aplicação: 2019',
        },
        '4ALL':{
             'CARGANDO':'Carregamento de resultados FORALL',
             'TITULO4ALL':'RESULTADOS DO ESTÁGIO',
             'TABPRACTICAS':{
              'TITULOTAB':'Prática 4all',
              'TITULOPRACGLOBAL':{
              'SUBTITULOPRAC':'Resultado global do estágio FORALL',
              'TEXTO1':'Percentagem de ',
              'TEXTO2':'conhecimento das práticas FORALL',
              'TEXTO3':'na sua organização',
              'TEXTO4':'Nível de',
              'TEXTO5':'satisfação dos empregados que sabem',
              'TEXTO6':'as práticas FORALL',
            },
            'TITULOPRAC4All':{
              'TITULOTAB':'Demográficos',
              'SUBTITULO4ALL':'Resultados por estágio FORALL',
              'TITULOCONO':'CONHECIMENTO',
              'TEXTO1':'Percentagem de conhecimento das práticas FORALL na sua organização',
              'TITULOSATIS':'SATISFAÇÃO',
              'TEXTO2':'Nível de satisfação dos empregados que estão familiarizados com a prática FORALL',
            },
          },

      'DEMOGRAFICOS':{
        'Cargo homologado ': 'Posição Aprovada ',
        'Años de Trabajo': 'Idade',
        'Condición de trabajo': 'Condições de trabalho',
        'Tipo de trabajo': 'Esquema de compensação',
        'Género': 'Género',
        'Educación': 'Grau académico',
        'PORCONOTXT1': 'Percentagem de',
        'PORCONOTXT2': 'conhecimento das práticas FORALL',
        'PORCONOTXT3': 'demograficamente',
        'PORSATITXT1': 'Nível de',
        'PORSATITXT2': 'satisfação dos empregados que estão familiarizados com as práticas FORALL',
        'PORSATITXT3': 'por corte demográfico',
      },
      'MODL_N_RESU':'Atualmente não há resultados',
      'MODL_N_RESU_4ALL':'Não é possível apresentar os resultados solicitados',
         },
         "ETIQ_MODAL_RESULT":{
           "TITLE_MODA":'No result platformKey found',
         "ETQ_PROD": "Produto: ",
         "ETQ_BROK": "Broker: ",
         "ETQ_COUN": "País: ",
         "ETQ_LANG": "Linguagem: ",
         "ETQ_CERTY": "Certificado: ",
         "true": "Capacitado",
         "false": "Deficiente",
         "COUNTR_NO_SELEC":"*Não seleccionado*",
         }
       },
       'CONFING_RESUL':{
       'TITULO_MODAL':'Configuração de resultados BenchMarks',
       'TAB_DEMO_EXCEL':'Dados demográficos Excel',
       'SUB_TIT_TAB_DEMO_EXCEL':'Selecione a demografia:',
       'TAB_DEMO_ENCU':'Pesquisa demográfica',
       'SUB_TIT_TAB_DEMO_ENCU':'Selecione a demografia:',
       'TAB_BENCHMA':'BenchMark',
       'SUB_TIT_TAB_BENCHMA':'',
       'TITULO_MAT_EXPAN_TAMANO':'Top',
       'TITULO_MAT_EXPAN_SECTOR':'Sectorial',
       'TITULO_MAT_EXPAN_REGIONAL':'Faixas de variação',
       'OKSELECT': 'Seleccionado',
       'NOTSELECT': 'Não seleccionado',
       'TAB_NIV_GEOG':'Níveis geográficos',
       'SUB_TIT_TAB_NIV_GEOG':'Selecionar níveis geográficos:',
       'TAB_NIV_ESTRUC':'Níveis estruturais',
       'SUB_TIT_TAB_NIV_ESTRUC':'Selecionar os níveis estruturais:',
       'BTN_ACEPTAR':'Aceitar',
       'MODAL_CARGA_DEMO_EXC':'Carregamento de dados demográficos',
       'MODAL_CARGA_DEMO_ENC':'Carregamento dos dados demográficos da pesquisa',
       'MODAL_CARGA_BENCH':'Benchmark de Carregamento',
       'MODAL_CARGA_NIV_GEO':'Carregamento de níveis geográficos',
       'MODAL_CARGA_NIV_ESTR':'Carregamento de níveis estruturais',
       'TAB_BENCH_MARK':'Benchmark',
       'MODAL_CARGA_BENCH_MARK': 'Carregamento de referência',
       'SUB_TIT_TAB_BENCH_MARK': 'Seleccionar referência:',
       'SUCCES_GUAR_SELEC':'As modificações foram salvas corretamente',
       'CONFI_GUAR_SELE':'Você tem certeza de salvar as mudanças que fez?',
       'RES_SI': 'Sim',
       'RES_NO':'Não',
       'MAT_TOOL_BTN_CONFI_RESULT':'Configuração dos resultados',
       'MODAL_GUA_INFOR':'Salvando informações',
       'SUB_TIT_TAB_HIERARCHI':'Seleção de percursos hierárquicos:',
       'MODAL_CARGA_HIERARCHI': 'Carregamento de Caminhos Hierárquicos',
       'SIN__HIERARCHI_MOSTRAR': 'Não há atualmente resultados em percursos hierárquicos',
       'EXTERNAL_PORTAL':'Copie a url do 4all externo',
      'INTRU_TEX_BENCHMARK':'*Move benchmarks',
      'BENCHMARCK_SELEC': 'BenchMark seleccionado por ordem de apresentação:',
      'BTN_SAV_BENCH': 'Save Benchmarks',
      'TEX_SEARC_BENCH_TOP': 'Introduza a referência superior para pesquisar',
      'TEX_SEARC_BENCH_SECT': 'Introduzir referência sectorial para pesquisar',
      'TEX_SEARC_BENCH_RANG': 'Introduza o intervalo de referência a pesquisar',
      'INFO_MAS_BENCH_ESPA':'pontos de referência agrupados',
      'BTN_ADD_BENCH_SUGE':'Adicionar sugestão',
      'MOD_WARN_MAX_PERMIT': 'Não é possível adicioná-lo, porque excede o número de espaços permitidos',
      'MOD_WARN_UN_CATE': 'Actualmente já existe uma referência da catergoria seleccionada',
      'MOD_WARN_NO_APLIC':'Não é possível adicioná-lo, uma vez que a opção de não seleccionar o BenchMarks está activada.',
      'INSTRU_DRAP&DROP_1':'Arrastar e largar o BenchMark aqui',
      'LABE_CIRC_PROGRE':'Benchmarks',
      'LABE_INSTRU_SELECT_BENCH':'¿Quer seleccionar BenchMarks?',
     },
     'CONFING_RESUL_GOFLOW':{
     'TITULO_MODAL':'GoFlow Informação de resultados',
       },
     'CONFING_RESUL_EMP':{
       'TITULO_MODAL': 'Raw Data Emprising',
        'INT_TEX':'Instrução: Favor carregar o arquivo Raw Data a ser importado',
        'TOOLT_CHA_INF': 'Selecionei o arquivo',
        'UPLO_INF': 'Importar dados de linha',
        'SUCC_UPLO_INF':'Importado com sucesso',
     }
    }
};
